import { ApiError } from '@/domains/general/api/apiError';

import { SessionExpiredError } from './sessionExpiredError';

/**
 * Wat er met de sessie moet gebeuren wanneer `GET /me` faalt.
 *
 * De API geeft 403 wanneer de gebruiker niet aan een perspectief hangt en 401
 * wanneer het token niet meer geldig is. Die twee mogen niet op één hoop: een
 * 401 is een verlopen sessie, geen autorisatieprobleem, en de gebruiker de
 * perspectief-melding tonen stuurt hem naar de verkeerde oplossing.
 */
export type MeFailure = 'session-expired' | 'no-perspective';

export function classifyMeFailure(error: unknown): MeFailure {
  // MSAL kon de sessie niet vernieuwen (zie msalAuth.ts).
  if (error instanceof SessionExpiredError) return 'session-expired';
  if (error instanceof ApiError && error.status === 401) return 'session-expired';
  // Netwerk- en serverfouten vallen hier bewust ook onder: dat is het
  // bestaande terugvalgedrag. Een eigen foutscherm daarvoor is apart werk.
  return 'no-perspective';
}
